module.exports = __webpack_public_path__ + "img/jiaohuan.a6aa6d2f.png";